module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/parts-9e032ee774d434e6eb7751c700d324cb.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/parts.svg
// module id = QId0
// module chunks = 24